import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';


const api = axios.create({
  baseURL: process.env.REACT_APP_BASEURL
})

const get = param => trackPromise(api.get(param));
const post = (param, body) => trackPromise(api.post(param, body));
const put = (param, body) => trackPromise(api.put(param, body));
const del = param => trackPromise(api.delete(param));

const getToken = async (request) => {
  const body = `client_id=${process.env.REACT_APP_CLIENT}&grant_type=client_credentials&client_secret=${process.env.REACT_APP_SECRET}`
  const url = process.env.REACT_APP_BASEURL_TOKEN
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body
  });
  const data = await response.json()

  request.headers['Authorization'] = 'Bearer ' + data.access_token;

  window.localStorage.setItem('token', 'Bearer ' + data.access_token);
  return request;
}

const download = (method, url, mimeType, filename) => {
  return new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest()
    xhr.open(method, url)
    xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
    xhr.responseType = 'arraybuffer'
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        const blobArquivo = new Blob([this.response], { type: `${mimeType}` })

        const fileURL = URL.createObjectURL(blobArquivo)

        const arquivoLink = document.createElement('a')
        arquivoLink.href = fileURL
        arquivoLink.setAttribute('download', filename)
        document.body.appendChild(arquivoLink)
        arquivoLink.click()

        resolve('')
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(`Não foi possível encontrar o arquivo ${filename}.`)
      }
    }
    xhr.onerror = function () {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`Não foi possível encontrar o arquivo ${filename}.`)
    }
    xhr.send()
  })
}

api.interceptors.request.use(
  async (request) => {
    request.headers['Authorization'] = window.localStorage.getItem('token');
    if (!request.headers.Authorization || request.headers.Authorization === 'Bearer undefined') {
      request = await getToken(request);
    }
    return request
  },
  error => {
    console.log('error')
  }
);

api.interceptors.response.use(response => {
  return response;
}, async err => {
  if (err.response && err.response.status === 401) {
    let originalReq = err.config;

    originalReq._retry = true;

    originalReq = await getToken(originalReq);
    try {
      var response = await axios(originalReq);
      return response;
    }
    catch (e) {
      return e.response
    }
  }
  return err.response;
}
);

export default {
  get,
  post,
  put,
  del,
  download
};